import { Component, inject, OnInit } from '@angular/core';
import { Validators, ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordsMatchValidation } from '../../../shared/validators/password-match.validator';
import { PasswordStrengthValidator } from '../../../shared/validators/password-strength.validator';
import { AuthenticationService } from '@flexyoo/auth';
import { LoggerService } from '@flexyoo/core';
import { GenericPageWithLogoComponent } from '@flexyoo/shared/ui';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';

import { MatInputModule } from '@angular/material/input';
import { catchError } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { HttpErrorHandlerService } from '@flexyoo/shared/services';

interface IFormValue {
  email: FormControl<string>;
  password: FormControl<string>;
  confirmPassword: FormControl<string>;
}

@Component({
  selector: 'app-choose-password',
  templateUrl: './choose-password.component.html',
  styleUrls: ['./choose-password.component.css'],
  imports: [
    GenericPageWithLogoComponent,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
  ],
})
export class ChoosePasswordComponent implements OnInit {
  hash: string;
  name: string;

  private readonly logger = inject(LoggerService);

  public readonly form: FormGroup<IFormValue> = new FormGroup(
    {
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required, PasswordStrengthValidator.validate]),
      confirmPassword: new FormControl('', Validators.required),
    },
    {
      validators: PasswordsMatchValidation.validate,
    }
  );

  constructor(
    private readonly authService: AuthenticationService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly httpErrorHandlerService: HttpErrorHandlerService
  ) {}

  ngOnInit() {
    if (!this.route.snapshot.queryParams.hash) {
      this.logger.error('No hash found');
      this.router.navigate(['/login']);
      return;
    }

    this.hash = encodeURIComponent(this.route.snapshot.queryParams.hash);
    this.name = this.route.snapshot.queryParams.name;
    this.form.patchValue({ email: this.route.snapshot.queryParams.email });
  }

  onSubmit() {
    if (this.form.valid) {
      this.form.disable();

      const password = this.form.get('password').value;

      this.authService
        .confirmEmployeePassword({ Hash: this.hash, Password: password })
        .pipe(
          catchError((error) => {
            this.form.enable();
            return this.httpErrorHandlerService.handleError(error);
          })
        )
        .subscribe((x) => {
          if (x) {
            this.router.navigateByUrl('/login');
          }
        });
    }
  }
}
